import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BuscadorResponse, PersonaBuscadorFotoData } from "src/common/buscador-personas";
import { PageQuery } from "src/common/page-query";
import { environment } from "src/environments/environment";

@Injectable()
export class BuscadorPersonasService {

	private readonly BUSCADOR_BASE_URL: string = environment.backendUrl + '/buscador-persona';
	private readonly FIND_PERSONAS_URL: string = this.BUSCADOR_BASE_URL + '/persona';
	private readonly FIND_PERSONA_FOTO_URL: string = this.BUSCADOR_BASE_URL + '/persona-foto';

	private readonly PAGE_NUM_PARAM: string = 'pageNum';
	private readonly PAGE_SIZE_PARAM: string = 'pageSize';
	private readonly SEARCH_TEXT_PARAM: string = "searchText";
	private readonly ID_PERSONA_PARAM: string = "idPersona";

	constructor( private http: HttpClient ){}

	findPersonasByPage( page: PageQuery, searchText: string ): Observable<BuscadorResponse> {
		let params: HttpParams = new HttpParams()
			.set( this.SEARCH_TEXT_PARAM, searchText )
			.set( this.PAGE_NUM_PARAM, page.pageNum.toString() )
			.set( this.PAGE_SIZE_PARAM, page.pageSize.toString() );
		return this.http.get<BuscadorResponse>( this.FIND_PERSONAS_URL, { params } );
	}

	findPersonaFoto( idPersona: number ): Observable<PersonaBuscadorFotoData> {
		let params: HttpParams = new HttpParams().set( this.ID_PERSONA_PARAM, idPersona.toString() );
		return this.http.get<PersonaBuscadorFotoData>( this.FIND_PERSONA_FOTO_URL, { params } );
	}

}